export default "/kiban/_next/static/images/speechBalloon-2f9804946bb44101a05fedb8e0cd96ec.png";